import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const CampaignsPage = lazy(() => import('./pages/CampaignsPage'));
const ListsPage = lazy(() => import('./pages/ListsPage'));
const EmailAnalyticsPage = lazy(() => import('./pages/EmailAnalyticsPage'));

export const EmailRoutes: RouteObject = {
  path: 'email',
  element: <ModuleGuard moduleId="marketing.email" />,
  handle: { crumb: 'Email Marketing' },
  children: [
    { index: true, element: <Navigate to="campaigns" replace /> },
    { path: 'campaigns', element: <CampaignsPage />, handle: { crumb: 'Campaigns' } },
    { path: 'lists', element: <ListsPage />, handle: { crumb: 'Lists' } },
    { path: 'email-analytics', element: <EmailAnalyticsPage />, handle: { crumb: 'Email Analytics' } },
  ],
};
